import * as CubeTree from '../../cubeTree/index';
import ShortCutKey from '../../interaction/shortcutkey/index';
import Select from '../../interaction/select/index';
import History from '../../interaction/history/index';
import Remove from '../../interaction/remove/index';
import Utils from '../../utils/util';
import { StageEvent } from '../../message/index';

interface PanelRemoveItem {
    cubeId: CubeId,
    parentCubeId: CubeId
}

interface PanelRemoveMsgParams {
    eventFrom: string,
    removeList: PanelRemoveItem[]
}

function init(): void {
    // 删除
    ShortCutKey.on({
        keyName: 'press+backspace',
        callback: (event) => {
            removeSelectCubes();
        }
    });

    ShortCutKey.on({
        keyName: 'press+del',
        callback: (event) => {
            removeSelectCubes();
        }
    });

    StageEvent.on('panelCubeRemove', (params: PanelRemoveMsgParams): void => {
        if (params.eventFrom === 'stage') {
            return;
        }

        panelRemove(params.removeList);
    });
}

function panelRemove(removeList: PanelRemoveItem[]): void {
    let delCubes: CubeId[] = removeList.map((item: PanelRemoveItem): CubeId => {
        return item.cubeId;
    }).filter((cubeId: CubeId): boolean => {
        return CubeTree.has(cubeId);
    });

    delCubes = Utils.unique(delCubes);
    removeCubes(delCubes);
}

function removeSelectCubes(): void {
    let delCubes: Array<CubeId> = Remove.findDelTargetsAllSelect();

    removeCubes(delCubes);
}

function removeCubes(delCubes: CubeId[]): void {
    History.stackIn({
        type: 'remove',
        data: delCubes
    });
    Remove.del(delCubes);
    Select.panelSelectAsync();
}

export default {
    init
};
